import styled from "@emotion/styled";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";

const FiltersContainer = styled.div`
  display: grid;
  grid-template-columns: 180px;
  margin-bottom: 0.5rem;
`;

export type DeliveryStatusFilter = "all" | "pending" | "succeeded" | "failed";

type Props = {
  value: DeliveryStatusFilter;
  onChange: (value: DeliveryStatusFilter) => void;
};

export const DeliveriesAuditFilters = (props: Props) => {
  const { value, onChange } = props;

  return (
    <FiltersContainer>
      <FormControl>
        <InputLabel id="delivery-status-filter-label">Status</InputLabel>
        <Select
          labelId="delivery-status-filter-label"
          label="Status"
          value={value}
          onChange={(event) =>
            onChange(event.target.value as DeliveryStatusFilter)
          }
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="succeeded">Succeeded</MenuItem>
          <MenuItem value="failed">Failed</MenuItem>
        </Select>
        <FormHelperText> </FormHelperText>
      </FormControl>
    </FiltersContainer>
  );
};
